import { CreditDataType, HaiXiaoQueryStatusType } from '@/api/homeV2Status/types';
import type { HomeSummaryResponse } from '@/api/rights/shop-mall/types';

/** 用户已授信的额度状态 */
export enum CreditedQuotaStatusEnum {
  /** 额度正常：有额度 */
  AMOUNT_NORMAL = 0,
  /** 额度为0，已用完：有订单，无额度 */
  USE_OUT_AMOUNT = 1,
  /** 额度为0，已过期：无订单，无额度 */
  NEVER_USED_AMOUNT = 2,
}
/** 用户授信状态数据 */
export type UserCreditData = CreditDataType;

/** banner广告数据 */
export interface MarketBannerAdvData {
  /** 广告图片 */
  marketSource: string;
  /** 广告高度 */
  marketHeight: string;
  /** 广告宽度 */
  marketWidth: string;
  /** 广告跳转链接 */
  marketUrl: string;
}

/** 首页store数据类型 */
export interface HomeStoreStateType {
  /** 额度更新-弹窗的展示状态：如，预授信出额 */
  creditAmountAlterPopupVisible: boolean;
  /** 额度更新-弹窗的额度 */
  creditAmountAlterPopupAmount: string | undefined;
  /** 用户授信数据 */
  userCreditData: UserCreditData | null;
  /** 是否只展示利率下限 */
  showRateTextExp: boolean | null;
  /** 是否展示品牌化文案（首页头部标题栏/金融卡片） */
  showBrandingExp: boolean | null;
  /** 海消联合品牌展示状态 */
  haiXiaoQueryData: HaiXiaoQueryStatusType | null;
  }

/** 首页营销展示类store数据类型 */
export interface HomeMarketStoreStateType {
  /** 分期商城是否展示 */
  installMallShow: boolean;
  /** 分期商城跳转地址 */
  installMallInfo: HomeSummaryResponse | null;
}

/** 首页弹窗类型 */
export enum HomeDailogTypeEnum {
  /** 天降红包 */
  TIAN_JIANG_MARKET = 'tianJiangMarket',
  /** 页面开屏弹窗：临额弹窗、营销弹窗 */
  PAGE_LOADED_POPUP = 'homeLoadedPopup',
  /** 首页退出挽留弹窗 */
  BACK_POPUP = 'backPopup',
}

/** 首页场景类型 */
export enum HomeSceneTypeEnum {
  /** 零用钱 */
  POCKET_MONEY = 'pocketMoney',
  /** 中收 */
  MIDDLEINCOME = 'middleIncome',
}

/** 中收首页数据 */
export interface MiddleIncomeData {
  /** 是否命中中收 BDI 人群 */
  platformMarketAccess: boolean;
  /** 产品列表 */
  includeBusiness: MiddleIncomeResponse[];
}

/** 中收首页模块类型 */
export enum MiddleIncomeBusinessTypeEnum {
  /** 分期商城 */
  SHOPPING_MALL = 'shoppingMall',
  /** 纯贷超半流程 */
  OVER_LOAN = 'overLoan',
  /** 车抵贷 */
  MORTGAGE_LOAN = 'mortgageLoan',
}

/** 中收首页模块默认埋点名称 */
export const DEFAULT_UBT_CARD_NAME_BY_BUSINESS_TYPE: Record<string, string> = {
  shoppingMall: 'finance_loan_home_shopMall',
  overLoan: 'finance_loan_dcHalfProcess_entry',
  mortgageLoan: 'finance_loan_mortgageloan_entry',
};


/** 中收首页模块数据 */
export interface MiddleIncomeResponse {
  /** 模块名称 */
  moduleName: string;
  /** 产品类型shoppingMall/overLoan/mortgageLoan */
  businessType: string;
  /** 副标题（subTitle） */
  subTitle: string;
  /** 引导文案（guideText） */
  guideText: string;
  /** 额度显示文案，如「最高可享 200,000」 */
  creditAmount: string;
  /** 按钮文案 */
  buttonText: string;
  /** 图标 */
  icon: string;
  /** 跳转链接 */
  jumpUrl: string;
  /** 是否老客，仅分期商城存在 */
  oldUser: boolean;
}
